import github from "./github"
import daynight from "./daynight"
import engineer from "./engineer"
import test from "./test"
import triangle from "./triangle"
import reset from "./reset"

export default {
  github,
  daynight,
  engineer,
  test,
  triangle,
  reset,
}
